<template>
  <div id="app">
    <Home />
  </div>
</template>
<script>
import Home from "./views/Home";
export default {
  components: { Home },
  created() {
    window.nfplusJsbridge.setShareInfo({
      shareDesc: `“南方+”创造更多价值！`,
      shareIcon: "https://static.nfapp.southcn.com/common/assets/images/nf_logo_share300x300.png",
      shareTitle: " ",
      shareUrl: window.location.href
    });
  },
  mounted() {
    try {
      window.initRecordSDK({
        env: process.env.VUE_APP_RUN_ENV
      });
    } catch (error) {
      window.console.log(error);
    }
  }
};
</script>
<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
